import { render, staticRenderFns } from "./Adzone.vue?vue&type=template&id=54c61e0c"
import script from "./Adzone.vue?vue&type=script&lang=js"
export * from "./Adzone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports